export enum AccountType {
  LongTerm = 'LongTerm',
  Retirement = 'Retirement',
}
